import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../components/Wrapper';
import range from 'lodash/range';
import Participant from '../components/Participant';
import { StyleSheet } from 'aphrodite/no-important';
import { BASE_SPACING } from '../styles';
import { navigateTo } from '../utils';
import { connect } from 'react-redux';
import { openConfirm, updateNode } from '../redux/app';

const s = StyleSheet.create({
  root: {
    padding: BASE_SPACING,
  },
});

class BracketParticipants extends React.Component {
  participantClick = (id) => {
    if (id) {
      return navigateTo(`/tree/edit/${this.props.id}/participant/${id}/edit`);
    }

    navigateTo(`/tree/edit/${this.props.id}/participant/create`);
  };

  renderParticipant = (participant, index) => {
    return (
      <Participant
        {...participant}
        key={index}
        onClick={this.participantClick}
      />
    );
  };

  render() {
    return (
      <Wrapper __className={s.root}>
        {this.props.participants.map(this.renderParticipant)}
        {range(
          this.props.participantCount - this.props.participants.length
        ).map(this.renderParticipant)}
      </Wrapper>
    );
  }
}

BracketParticipants.propTypes = {
  title: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  participants: PropTypes.array,
  participantCount: PropTypes.number,
  openConfirm: PropTypes.func,
  nodes: PropTypes.array,
  updateNode: PropTypes.func,
};

BracketParticipants.defaultProps = {
  participants: [],
};

const mapDispatchToProps = (dispatch) => ({
  updateNode: (data, ids) =>
    dispatch(
      updateNode(
        {
          participantId: data.participants,
          winnerId: data.participants.includes(data.winner)
            ? data.winner
            : null,
        },
        ids
      )
    ),
  openConfirm: (props) => dispatch(openConfirm(props)),
});

export default connect(undefined, mapDispatchToProps)(BracketParticipants);
